// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2IPdQ","footer":"ModalError_footer__2_GdM"};